<div>
  <header class="header header-2 customHeader">
    <button
      disabled
      style="opacity: 1;"
      class="btn customHeaderButton"
      routerLink="home"
      routerLinkActive="btn-success"
      routerLinkActive
      #rlaHome="routerLinkActive"
      [ngClass]="rlaHome.isActive ? 'btn-success' : 'btn-inverse'"
    >
      1. Demo Steps
    </button>
    <button
      disabled
      style="opacity: 1;"
      class="btn customHeaderButton"
      routerLink="view-users"
      routerLinkActive="btn-success"
      routerLinkActive
      #rlaAllUsers="routerLinkActive"
      [ngClass]="rlaAllUsers.isActive ? 'btn-success' : 'btn-inverse'"
    >
      2. View All Users
    </button>
    <button
      disabled
      style="opacity: 1;"
      class="btn customHeaderButton"
      routerLink="control-users"
      routerLinkActive
      #rlaControlAllUsers="routerLinkActive"
      [ngClass]="rlaControlAllUsers.isActive ? 'btn-success' : 'btn-inverse'"
    >
      3. Control All Users
    </button>
  </header>

  <router-outlet></router-outlet>
</div>
